export const GET_EXCERCISE = 'excercise/GET_EXCERCISE';
export const GET_EXCERCISE_SUC = 'excercise/GET_EXCERCISE_SUC';
export const GET_EXCERCISE_ERR = 'excercise/GET_EXCERCISE_ERR';

export const SAGA_GET_EXCERCISE = 'excercise/SAGA_GET_EXCERCISE';